module.exports = __webpack_public_path__ + "img/pw.31ac4739.svg";